
import { defineComponent, PropType } from 'vue'
import ProductCard from '@/pages/Products/components/ProductCard.vue'
import { CtProduct } from '@/models/interfaces/content-type'
import AddIcon from '@/components/Icons/AddIcon.vue'
import DButton from '@/components/base/DButton.vue'
import { useRouter, onBeforeRouteLeave } from 'vue-router'

export default defineComponent({
  name: 'ProductsList',
  components: { DButton, AddIcon, ProductCard },

  props: {
    paginatedProducts: {
      type: Array as PropType<Array<CtProduct>>
    },
    loading: {
      type: Boolean
    },
    page: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 12,
    },
    maxPage: {
      type: Number,
      default: 1,
    },
    productTotal: {
      type: Number,
      default: 0,
    },
  },

  emits: ['add-product', 'update:page', 'set-recent-product'],

  setup (props, { emit }) {
    const $router = useRouter()

    const handleAddProduct = ($event) => {
      emit('add-product')
    }

    const productRoute = (productId) => {
      // localStorage.setItem('previousQuery', JSON.stringify($router.currentRoute.value.query))
      void $router.push({ name: 'ProductDetailIndex', params: { productId: productId, editing: '' } })
      emit('set-recent-product', productId)
    }

    onBeforeRouteLeave((to, from, next) => {
      if (to.name === 'ProductDetailIndex') {
        const previousRouteInfo = {
          previousRouteName: from.name,
          query: $router.currentRoute.value.query,
        }
        localStorage.setItem('previousRouteInfo', JSON.stringify(previousRouteInfo))
      }
      next()
    })


    return {
      handleAddProduct,
      productRoute,
    }
  }
})
